export const state = {
  liffId: null,
  liffReady: false,
  liffProfile: null
}



// WEBPACK FOOTER //
// ./src/store/line/state.js